import { apiBaseUrl } from '@/services/http-client';

/**
 * Foto de uma seção, vinda do painel.
 *
 * Sem foto, o quadro fica com o fundo de areia e a proporção certa — o desenho
 * da seção se mantém e nada finge ser o que não é. É o estado em que o site
 * nasce, enquanto o cliente não entrega as imagens dele.
 *
 * A rota da mídia responde `immutable`, e o identificador muda quando a imagem
 * muda: pode carregar direto por `<img>`, sem passar por JavaScript.
 */
export function ImagemDaSecao({
  mediaId,
  alt,
  proporcao,
  className,
  children,
}: {
  mediaId: string | null;
  /** Vazio quando a foto é decorativa — e aí ela sai do leitor de tela. */
  alt: string;
  proporcao: string;
  className?: string;
  children?: React.ReactNode;
}) {
  return (
    <figure className={`relative m-0 overflow-hidden bg-sand ${className ?? ''}`}>
      {mediaId === null ? (
        <div aria-hidden="true" className={`w-full ${proporcao}`} />
      ) : (
        <img
          src={`${apiBaseUrl}/api/v1/media/${mediaId}`}
          alt={alt}
          aria-hidden={alt === '' ? true : undefined}
          loading="lazy"
          decoding="async"
          className={`h-full w-full object-cover ${proporcao}`}
        />
      )}
      {children}
    </figure>
  );
}
